// WebSocket.js
import io from 'socket.io-client';
import { chatProductionAddr } from '../networkConfig';

console.log("file called again");

let socket = null;

function initSocket() {
  const token = localStorage.getItem('token');
  if (!token) {
    console.warn('No token, skipping socket init');
    return null;
  }

  const isProd = chatProductionAddr.includes('prod-chatapi.stockants.com');
  const SocketIoUrl = isProd ? 'https://prod-chatapi.stockants.com:9002' : 'wss://uat-chatapi.stockants.com:8002';

  socket = io(SocketIoUrl, {
    reconnection: true,
    reconnectionAttempts: 5,       // Max number of reconnection attempts
    reconnectionDelay: 1000,       // Wait 1s before next attempt
    reconnectionDelayMax: 5000,    // Max wait time between attempts
    // timeout: 20000,                // 20s connection timeout
    autoConnect: true,
    extraHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });

  socket.on("connect", () => {
    console.warn(`Socket connected`, socket);
  });

  socket.on('reconnect_attempt', (attempt) => {
    console.warn(`Reconnect attempt #${attempt}`);
  });

  socket.on('reconnect_failed', () => {
    console.error('Reconnect failed');
  });

  socket.on('reconnect', (attemptNumber) => {
    console.log(`Reconnected after ${attemptNumber} attempt(s)`);
  });

  socket.on('connect_error', (err) => {
    console.error('Connection error:', err.message, socket);
  });

  socket.on('connect_timeout', () => {
    console.error('Connection timeout');
  });

   socket.on('disconnect', () => {
    console.log('Disconnected from server');
  });

  return socket;
}

function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

const SocketPlugin = {
  install(Vue) {
    Vue.prototype.$socket = null;

    Vue.prototype.$initChatSocket = () => {
      // disconnectSocket();
      const newSocket = initSocket();
      Vue.prototype.$socket = newSocket;
      // window.$socket = newSocket;
    };

    if (localStorage.getItem('token')) {
      const newSocket = initSocket();
      Vue.prototype.$socket = newSocket;
      // window.$socket = newSocket;
    }
  }
};

export default SocketPlugin;

